import { logWrapper } from '../../utils';

export default {
  questionModalController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$uibModal',
    'revisionListService',
    'folderService',
    '$window',
    'EDocumentStatus',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      uibModal,
      revisionListService,
      folderService,
      $window,
      EDocumentStatus,
      ETreeItemTypes,
    ) {
      'use strict';

      function parent_cancelButton() {
        $scope.modalQuestion.close();
        $scope.modalRemoveDocument.close();
      }

      function questionModal() {
        if ($scope.questionFolder === true) {
          return new Promise(function (resolve) {
            folderService.delete($scope.folder, true).then(
              function () {
                $scope.folder.removed = true;
                $scope.folder.HasChildrens = function () {
                  var notRemoved =
                    $scope.folder.Children &&
                    $scope.folder.Children.filter(function (item) {
                      return (
                        !item.removed &&
                        !(item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE || item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
                      );
                    });
                  if (
                    $scope.folder.HasChildren &&
                    ($scope.folder.Children === null || notRemoved.length > 0)
                  ) {
                    return true;
                  } else {
                    return false;
                  }
                };
                $rootScope.$broadcast('loadFolder', $scope.folder.IdParent);
                $scope.modalRemoveDocument.close();
                $scope.modalQuestion.close();
                $window.location.reload();
                resolve();
              },
              function (error) {
                $scope.messageTitle = error.title;
                $scope.messageDescription = error.text;
                $scope.messageCancel = 'OK';
                $scope.modalRemoveDocument = uibModal.open({
                  scope: $scope,
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modal/errorModal/errorModal.html',
                  controller: 'homeController',
                  size: 'small',
                  windowClass: 'modal-remove',
                  resolve: {},
                });
              }
            );
          });
        } else {
          if ($scope.modalRemoveDocument) {
            $scope.modalRemoveDocument.close();
          }

          if ($scope.modalQuestion) {
            $scope.modalQuestion.close();
          }

          if ($scope.docs) {
            revisionListService
              .restore($scope.ids)
              .then(() => {
                for (var i = 0, len = $scope.docs.length; i < len; i++) {
                  var rev = $scope.docs[i];
                  rev.removed = undefined;
                  if (rev.idStatus === EDocumentStatus.IN_FLOW_TRASH_CAN) {
                    rev.idStatus = EDocumentStatus.IN_FLOW;
                  } else {
                    rev.idStatus = EDocumentStatus.ENABLED;
                  }
                  $scope.loadDocuments();
                }
              })
              .catch((error) => {
                throw new Error(error);
              });
          } else {
            $rootScope.$broadcast('RESUME_AUTO_REFRESH');
            $rootScope.$broadcast('RELOAD_DIGITALIZATIONS');

            $scope.modalProperties.close();
          }
        }
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
